import * as TYPES from '../types';

export const loadingStartAction = () => {
    return {
        type: TYPES.LOADING_START,
    };
};

export const loadingEndAction = () => {
    return {
        type: TYPES.LOADING_END,
    };
};
